import { createSlice } from '@reduxjs/toolkit';

export const userReducer = createSlice({
  name: 'user',
  initialState: {
    user: null,
    currentEmployer: { id: 0 },
  },
  reducers: {
    updateUser: (state, action) => {
      state.user = {...action.payload};
      localStorage.setItem('user', JSON.stringify(state.user));
    },
    updateEmployer: (state, action) => {
      state.currentEmployer = {...action.payload};
      localStorage.setItem('employer', JSON.stringify(state.currentEmployer));
    },
  },
});

export const { updateUser, updateEmployer, updateAvailableEmployers } = userReducer.actions;
export default userReducer.reducer;
